import { type Ref } from "vue";

/**
 * Shared form helper utilities
 * Used by both RentalTaskDetail and ForceTaskDetail
 */
export function useFormHelpers(formRef: Ref, state: { taskInfo: Record<string, any> }) {
  /**
   * Check if form has any user-entered data
   */
  const hasData = (): boolean => {
    const m: any = formRef.value?.model || state.taskInfo;
    if (!m) return false;
    
    return Object.keys(m).some((k) => {
      const v: any = m[k];
      if (v === undefined || v === null) return false;
      if (typeof v === 'string') return v.trim().length > 0;
      if (typeof v === 'number') return !Number.isNaN(v);
      if (typeof v === 'boolean') return v === true;
      if (Array.isArray(v)) return v.length > 0;
      if (typeof v === 'object') return Object.keys(v).length > 0;
      return false;
    });
  };

  return {
    hasData,
  };
}
